'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESET = exports.FILTER = exports.UPDATE_VALUE = exports.INVALIDATE = exports.RESPONSE = exports.REQUEST = exports.SELECT = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.invalidate = invalidate;
exports.filter = filter;
exports.reset = reset;
exports.setData = setData;
exports.fetchIfNeeded = fetchIfNeeded;
exports.is = is;
exports.updateValue = updateValue;

var _utils = require('./../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SELECT = exports.SELECT = 'detail.select';
var REQUEST = exports.REQUEST = 'detail.request';
var RESPONSE = exports.RESPONSE = 'detail.response';
var INVALIDATE = exports.INVALIDATE = 'detail.invalidate';
var UPDATE_VALUE = exports.UPDATE_VALUE = 'detail.update_value';
var FILTER = exports.FILTER = 'detail.simple.filter';
var RESET = exports.RESET = 'detail.simple.reset';

/**
 * Zneplatnění dat.
 * @param area oblast
 * @param id objektu pro invalidaci
 * @returns {{type: string, area: *, data: *}}
 */
function invalidate(area, id) {
    return {
        type: INVALIDATE,
        area: area,
        id: id
    };
}

/**
 * Filtrování detailu.
 * @param area oblast
 * @param filter filtr
 * @returns {{type: string, area: *, filter: *}}
 */
function filter(area, filter) {
    return {
        type: FILTER,
        area: area,
        filter: filter
    };
}

/**
 * Reset reduceru na původní initial values a stav.
 * @param area oblast
 * @returns {{type: string, area: *}}
 */
function reset(area) {
    return {
        type: RESET,
        area: area
    };
}

/**
 * Nastavení konkrétních dat předanými, nastavením se aktualizuje i stav fetched a isFetching tak, aby byl výsledek stejný jako po reálném načtení dat ze serveru
 * @param area oblast
 * @param id dat
 * 
 * @param data data
 */
function setData(area, id, data) {
    return function (dispatch, getState) {
        // Načtení aktuálního store
        var store = (0, _utils.storeFromArea)(getState(), area);

        // Pokud ve store není potřebné id, dáme ho tam, aby se nám správně spočetl data key
        if (store.id !== id) {
            dispatch(select(area, id));
            store = (0, _utils.storeFromArea)(getState(), area);
        }

        var dataKey = store.getDataKey.bind(store)();

        // Simulace request dat
        dispatch(request(area, dataKey));

        // Response dat
        dispatch(response(area, data));
    };
}

/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param id id objektu, které má být ve store
 * @param getData metoda která má vrátit promise pro načtení, vstupem dostane id, předpis: (id, filter) => {}
 */
function fetchIfNeeded(area, id, getData) {
    return function (dispatch, getState) {
        // Načtení aktuálního store
        var store = (0, _utils.storeFromArea)(getState(), area);

        // Pokud ve store není potřebné id, dáme ho tam, aby se nám správně spočetl data key
        if ((0, _stringify2.default)(store.id) !== (0, _stringify2.default)(id)) {
            dispatch(select(area, id));
            store = (0, _utils.storeFromArea)(getState(), area);
        }

        var dataKey = store.getDataKey.bind(store)();
        if (store.currentDataKey !== dataKey) {
            // pokus se data key neschoduje, provedeme fetch
            dispatch(request(area, dataKey));

            var _filter = store.filter;
            if (id !== null) {
                // pokud chceme reálně načíst objekt, provedeme fetch přes getData
                getData(id, _filter).then(function (json) {
                    var newStore = (0, _utils.storeFromArea)(getState(), area);
                    var newDataKey = newStore.getDataKey.bind(newStore)();
                    if (newDataKey === dataKey) {
                        // jen pokud příchozí objekt odpovídá dtům, které chceme ve store
                        dispatch(response(area, json));
                    }
                }); // TODO [stanekpa] - řešit catch a vrácení datakey!
            } else {
                // Response s prázdným objektem
                dispatch(response(area, null));
            }
        }
    };
}

/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */
function is(action) {
    switch (action.type) {
        case REQUEST:
        case RESPONSE:
        case SELECT:
        case INVALIDATE:
        case FILTER:
        case RESET:
        case UPDATE_VALUE:
            return true;
        default:
            return false;
    }
}

/**
 * Úprava hodnoty ve store - vykonána uživatelem/programem
 * @param area oblast
 * @param data nová data
 * @returns {{type: string, area: *, data: *}}
 */
function updateValue(area, data) {
    return {
        type: UPDATE_VALUE,
        area: area,
        data: data
    };
}

/**
 * Výběr nového detailu, volá se i v případě, že je zavoláno fetchIfNeeded s jiným id něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */
function select(area, id) {
    return {
        type: SELECT,
        area: area,
        id: id
    };
}

/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */
function request(area, dataKey) {
    return {
        type: REQUEST,
        area: area,
        dataKey: dataKey
    };
}

/**
 * Response dat.
 * @param area oblast
 * @param data nová data
 * @returns {{type: string, area: *, data: *}}
 */
function response(area, data) {
    return {
        type: RESPONSE,
        area: area,
        data: data
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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